import React from 'react';

/**
 * TemplatesPanel component for GuiBuilder
 * Layout templates browser and quick actions
 */
export default function TemplatesPanel({ setShowTemplatePicker, setProperties, setPages, setActivePageIndex }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
            <h4 style={{ 
                fontSize: '0.8rem', 
                fontWeight: 700, 
                textTransform: 'uppercase', 
                letterSpacing: '0.05em', 
                color: 'var(--text-secondary)', 
                margin: 0 
            }}>
                Layout Templates
            </h4>
            
            <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', lineHeight: 1.5, margin: 0 }}>
                Choose from pre-defined templates to quickly set up your configurator layout. Each template includes a structured page layout and styling that you can customize.
            </p>

            <button 
                onClick={() => setShowTemplatePicker(true)}
                className="btn-primary"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.5rem',
                    width: '100%',
                    padding: '0.75rem',
                    fontSize: '0.9rem',
                    fontWeight: 600,
                    marginTop: '0.5rem'
                }}
            >
                <i className="fa-solid fa-layer-group"></i> Browse Templates
            </button>

            <div style={{ borderTop: '1px solid var(--border)', paddingTop: '1rem' }}>
                <h4 style={{ 
                    fontSize: '0.8rem', 
                    fontWeight: 700, 
                    textTransform: 'uppercase', 
                    letterSpacing: '0.05em', 
                    color: 'var(--text-secondary)', 
                    margin: '0 0 0.75rem 0' 
                }}>
                    Quick Actions
                </h4>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    <button 
                        onClick={() => {
                            setPages([
                                {
                                    id: 'page-1',
                                    title: 'Configuration',
                                    description: 'Main configuration page',
                                    elements: []
                                }
                            ]);
                            setActivePageIndex(0);
                        }}
                        className="btn-secondary"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            width: '100%',
                            justifyContent: 'flex-start',
                            padding: '0.6rem 1rem',
                            fontSize: '0.85rem'
                        }}
                    >
                        <i className="fa-solid fa-file" style={{ color: 'var(--text-secondary)' }}></i> Start from Scratch
                    </button>

                    <button 
                        onClick={() => {
                            setProperties(prev => ({
                                ...prev,
                                layoutTemplate: 'split-70-30',
                                layoutMapping: {
                                    column1: ['features-view', 'wizard-navigation'],
                                    column2: ['selections-overview']
                                }
                            }));
                        }}
                        className="btn-secondary"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            width: '100%',
                            justifyContent: 'flex-start',
                            padding: '0.6rem 1rem',
                            fontSize: '0.85rem'
                        }}
                    >
                        <i className="fa-solid fa-columns" style={{ color: 'var(--text-secondary)' }}></i> Default Split Layout
                    </button>
                </div>
            </div>
        </div>
    );
}
